import React from 'react'

const About = () => {
    return (
        <div>
            This is Aboutpage
        </div>
    )
}

export default About
